<template>
  <div id="FileInfo" class="file-info">
    <div class="file-row">
      <span>{{ versionFileInfo.name }}</span>
      <div class="flex-align-center">
        <span>适配：</span>
        <software-display :software-arr="versionFileInfo.softwareList" :software-version-name="versionFileInfo.softwareVersionName || versionFileInfo.softwareVersion" />
      </div>
      <span>大小：{{ `${formatFileSize(versionFileInfo.fileSize)}${versionFileInfo.fileSizeUnit}` }}</span>
      <div class="file-oper">
        <el-button
          type="text"
          title="下载当前启用的版本资源"
          @click="toDownload"
          v-if="clientType === 'web'"
        >
          下载
        </el-button>
        <el-button
          v-if="showPlaceButton"
          type="text"
          title="布置当前启用的版本资源"
          @click="toPlace"
        >
          布置
        </el-button>
        <el-button
          v-if="showLoadButton"
          type="text"
          title="载入当前启用的版本资源"
          @click="$emit('toLoad')"
        >
          载入
        </el-button>
      </div>
    </div>
    <select-component-type v-if="clientType !== 'web' && ['COMPONENT'].includes(resourceType)" ref="pluginPlaceTypeDialog" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SelectComponentType from './SelectComponentType.vue'
import SoftwareDisplay from '@/components/business/resource/SoftwareDisplay.vue'

export default {
  name: 'FileInfo',
  props: {
    resourceType: {
      type: String,
      default: 'COMPONENT'
    }
  },
  data() {
    return {}
  },
  components: { SelectComponentType, SoftwareDisplay },
  computed: {
    ...mapGetters({
      currentResource: 'resourceDetail/currentResource',
      versionResourceInfo: 'resourceDetail/versionResourceInfo',
      versionFileInfo: 'resourceDetail/versionFileInfo',
      clientTypeSoftwareCode: 'softwareCode',
      clientTypeSoftwareVersion: 'softwareVersion',
      clientType: 'platform',
      isCapitalSoftware: 'isCapitalSoftware',
      user: 'user/user'
    }),
    getPageType() {
      return this.$route.name
    },
    showPlaceButton() {
      const hasMatchedSoftwareCode = Array.isArray(this.versionResourceInfo.softwareList) && !!this.versionResourceInfo.softwareList.find((item) => item.softwareCode === this.clientTypeSoftwareCode)
      return this.clientType !== 'web' && ['COMPONENT'].includes(this.resourceType) && !this.isCapitalSoftware && hasMatchedSoftwareCode && this.clientTypeSoftwareVersion >= this.versionFileInfo.softwareVersion
    },
    showLoadButton() {
      const hasMatchedSoftwareCode = Array.isArray(this.versionResourceInfo.softwareList) && !!this.versionResourceInfo.softwareList.find((item) => item.softwareCode === this.clientTypeSoftwareCode)
      return this.clientType === 'g' && hasMatchedSoftwareCode && this.clientTypeSoftwareVersion >= this.versionFileInfo.softwareVersion
    }
  },
  methods: {
    formatFileSize(size) {
      if (size || size === 0) {
        return size.toFixed(2)
      } else {
        return ''
      }
    },
    async toDownload() {
      try {
        const { spaceId, spaceResourceId, versionId } = this.currentResource
        const dataVersionId = this.versionResourceInfo.dataVersionId
        const url = await this.$api.resource.getDownloadUrl(spaceId, spaceResourceId, versionId, dataVersionId)
        if (url) {
          this.$downloadFile(url)
          const eventMap = {
            COMPONENT: 'downloadSpaceComponent',
            MODULE: 'downloadSpaceModule',
            SCHEME: 'downloadSpaceScheme',
          }
          const eventName = eventMap[this.resourceType]
          this.$tracks({
            event: eventName,
            params: {
              g_c_space_id: spaceId,
              g_c_file_id: spaceResourceId,
            }
          })
        } else {
          this.$message.error('获取下载地址失败')
        }
      } catch (e) {
        console.log(e)
        this.$message.error('获取下载地址失败')
      }
    },
    toPlace() {
      if (this.getPageType === 'ComponentList') {
        this.$emit('toPlace')
        return
      }
      this.$refs.pluginPlaceTypeDialog && this.$refs.pluginPlaceTypeDialog.openDialog(this.currentResource.spaceId, { ...this.currentResource, id: this.currentResource.versionId }, false)
    },
  }
}
</script>

<style lang="less" scoped>
.file-row{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  border: 1px solid @border-color-tag;
  border-radius: 5px;
  background: @bg-grey-light;
  padding: 9px 16px;
  .el-button--small {
    padding: 0px;
  }
}
</style>
